/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from "./Classes/Helper";
import FocusHandler from "./Classes/FocusHandler";
import LazyLoad from "./Classes/Lazyload";
import ResponsiveTable from "./Classes/ResponsiveTable";
// import XDownloader from "./Classes/XDownloader";
import Video from "./Classes/Video";
import SliderHandler from "./Classes/SliderHandler";
import Esg from "./Classes/Esg";

import Accordion from './Classes/Accordion';
import NotesCorrection from './Classes/NotesCorrection';
import Header from './Classes/Header';
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
import YoutubeLinks from "./Classes/YoutubeLinks";

import CountUpNumbers from './Classes/CountUpNumbers';
import Gri from "./Classes/Gri";

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;

var esgInstance = null;

var accordionInstance = null;
var notesCorrectionInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;

export default {
  version: () => {
    return NSContext.theme.version;
  },

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }
};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  new Header ();

  new CountUpNumbers({
    numbersSelector: '.ns-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: [' ',''],
  });


  const accordionInstance = new Accordion({
    accordions: '.js-slide-toggler'
  });

  const notesCorrectionInstance = new NotesCorrection({
    ncTitle: '.accordion--notes .ns-title-h2'
  });

  const headerSlider = new SliderHandler({
    sliderType: 'header',
    outerWrapperSelector: '.slider--header'
  });

  const articleSlider = new SliderHandler({
    sliderType: 'articles',
    outerWrapperSelector: '.slider--article-tiles'
  });

  const storySlider = new SliderHandler({
    sliderType: 'articles',
    outerWrapperSelector: '.slider--story-tiles'
  });


  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  new Video();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: ".ns-table-wrap table",
    tableWrapperSelector: ".ns-table-wrap",
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: [],
  });

  // downloaderInstance = new XDownloader({
  //   downloadText: "Download Excel", //Can be empty if you want to use an icon instead
  //   backgroundColor: "6ab04c", //Colored Cells Background
  //   backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
  //   borderColor: '95afc0', //Color of border
  //   borderStyle: 'thin', // thin/dotted/medium/double/thick
  //   headClass: 'head', //Class you want your columns based on. Will be bold in Excel
  //   boldClass: 'title', //Class for Bold text in Excel
  //   borderClass: 'ns-borderbottom-line_dots'
  // });


  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  youtubeLinksInstance = new YoutubeLinks();

  new Gri();

  new Esg();
});
